import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setAppLoading, setAppLoaded } from "actions/app";
import Link from "components/elements/link";
import NotificationBox from "components/elements/notification-box";
import SVG from "components/elements/svg";
import TextContent from "components/elements/text-content";
import Api from "services/api";
import AuthService from "services/auth";

class SignInForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      error: () => null,
    };
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.state.submitting) {
      const { email: emailField, password: passwordField } = e.target;
      const { redirect } = this.props;
      const email = emailField.value;
      const password = passwordField.value;
      this.props.setAppLoading();
      this.setState({ submitting: true }, () => {
        AuthService.logIn(email, password)
          .then((tokens) => {
            AuthService.setTokensCookies(tokens);
            this.setState({ submitting: false, error: () => null }, () => {
              window.location.href = redirect || "/my-account/notifications";
            });
          })
          .catch((error) => {
            const newState = {
              error: () => (
                <TextContent content={error.hint || error.message} />
              ),
              submitting: false,
            };
            this.setState(newState, () => {
              this.props.setAppLoaded();
            });
          });
      });
    }
  }

  render() {
    const { submitting, error } = this.state;
    return (
      <div className="sign-in-form">
        <h2 className="section-heading">Sign in</h2>

        <NotificationBox type="danger">{error()}</NotificationBox>

        <form onSubmit={(e) => this.handleSubmit(e)}>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="required" htmlFor="email">
                  E-mail address
                </label>
                <input
                  type="email"
                  id="email"
                  className="form-control"
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label className="required" htmlFor="password">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  className="form-control"
                  required
                />
              </div>
            </div>
          </div>
          <div className="actions">
            <div className="actions__recovery">
              <Link to="sign-in/forgot-password" className="text-medium">
                I forgot my password »
              </Link>
            </div>
            <div className="actions__submit">
              <button
                type="submit"
                className={`btn btn-primary with-arrow ${
                  submitting ? "submitting" : ""
                }`}
              >
                <span>Sign in</span>
                <SVG src="arrow-right" className="arrow" />
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

SignInForm.propTypes = {
  setAppLoaded: PropTypes.func,
  setAppLoading: PropTypes.func,
  redirect: PropTypes.string,
};

SignInForm.defaultProps = {
  setAppLoaded: () => null,
  setAppLoading: () => null,
  redirect: "",
};

export default connect(() => ({}), { setAppLoading, setAppLoaded })(SignInForm);
